import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {isEmpty, postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {KEYWORD_TYPE} from "../@constants";
import {shareOfSearchKpiIsEmpty, resetShareOfSearchKpiSignals} from "../@signals";

export default function useShareOfSearchKpiFilters() {
	const { showToast } = useAppToast()
	const data = useSignal([])
	const aggregation = useSignal([])
	const keywords = useSignal([])
	const keywordType = useSignal(KEYWORD_TYPE.KEYWORD_TYPE)

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			data.value = []
			resetShareOfSearchKpiSignals()
			postSubmit(`${WEBBACK_V2_API}/share-of-search/kpi/context`, {
				...commonFiltersValue.value,
				keywordType: keywordType.value
			}).then(res => {
				if (!res.data?.length) shareOfSearchKpiIsEmpty.value = true
				else batch(() => {
					data.value = res.data
					aggregation.value = res.aggregations
					keywords.value = res.keywords
				})
			}).catch(() => isSystemBusy.value = true
			).finally(() => isLoadingCommonFilters.value = false)
		})
	}, [isLoadingCommonFilters.value]);

	const handleTabChange = useCallback((_, newValue) => batch(() => {
		keywordType.value = newValue
		isLoadingCommonFilters.value = true
	}), [])

	return {
		data: data.value,
		aggregation: aggregation.value,
		keywords: keywords.value,
		keywordType: keywordType.value,

		handleTabChange
	}
}